import Container from '@components/Container/Container';
import { StyledFooter } from './Footer.styled';
import Stack from '@mui/material/Stack';
import Image from 'next/image';
import Typography from '@mui/material/Typography';
import * as ROUTES from '@constants/routes';
import TypographyLink from '@components/TypographyLink/TypographyLink';
import Link from 'next/link';

const Footer = () => {
  const navLinks = [
    // {
    //   label: 'Terms',
    //   href: ROUTES.TOS,
    // },
    // {
    //   label: 'Privacy policy',
    //   href: ROUTES.PRIVACY_POLICY,
    // },
    // {
    //   label: 'Download branding',
    //   href: ROUTES.BRANDING,
    // },
  ];

  return (
    <StyledFooter>
      <Container>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ md: 'center' }}
          justifyContent="space-between"
          spacing={{ xs: 4, md: 0 }}
        >
          <Stack direction="row" alignItems="center" spacing={6}>
            {/* <a style={{ display: 'flex', alignItems: 'center' }}>
              <Link href="/" passHref={true}>
                <Image
                  src="/images/logo.svg"
                  alt="Logo"
                  width={176}
                  height={40}
                />
              </Link>
            </a> */}

            <Typography
              variant="body2"
              sx={{
                color: 'rgba(255, 255, 255, 0.8) !important',
                display: { xs: 'none', md: 'block' },
              }}
            >
              Copyright WALNUTS.FARM {new Date().getFullYear()}. All Rights Reserved.
            </Typography>
          </Stack>
          {/* <Stack direction="row" spacing={4}>
            {navLinks.map((link, index) => (
              <TypographyLink
                href={link.href}
                variant="body2"
                color="text.secondary"
                key={`footer-link-${index}`}
              >
                {link.label}
              </TypographyLink>
            ))}
          </Stack> */}
        </Stack>
        <Typography
          variant="body2"
          sx={{
            color: 'rgba(255, 255, 255, 0.8) !important',
            display: { md: 'none' },
          }}
          mt={4}
        >
          Copyright WALNUTS.FARM {new Date().getFullYear()}. All Rights Reserved.
        </Typography>
      </Container>
    </StyledFooter>
  );
};

export default Footer;
